/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const stopListItemSchema = z.object({
	productId: z.uuid(),
	sizeId: z.uuid().nullish(),
	balance: z.number().nullish(),
});
